import { all, call, put, takeLatest, fork } from 'redux-saga/effects';
import { Creators as TransferRetiredActions, Types as TransferRetiredTypes } from '../ducks/TransationRetired';
import api from '../../util/Api';
import * as Sentry from '@sentry/react';

function* getTransationRetired({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/transactions/gasrecs', {
      params: payload,
    });
    if (status === 200) {
      yield put(TransferRetiredActions.getTransationRetiredSuccess(data));
    } else {
      Sentry.captureMessage('getTransationRetired failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(TransferRetiredActions.getTransationRetiredError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(TransferRetiredActions.getTransationRetiredError());
  }
}

function* getGasrecRetired({ payload }) {
  try {
    const { status, data } = yield call(api.get, '/transactions/gasrecs-retired', {
      params: payload,
    });
    if (status === 200) {
      yield put(TransferRetiredActions.getGasrecRetiredSuccess(data));
    } else {
      Sentry.captureMessage('getGasrecRetired failed: status not 200', {
        level: 'error',
        extra: { payload, status, data },
      });
      yield put(TransferRetiredActions.getGasrecRetiredError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
    yield put(TransferRetiredActions.getGasrecRetiredError());
  }
}


function* getPdfTransation({ payload }) {
  try {
    const {status} = yield call (api.get, `transation/getPdf/${payload}`,
      {
        params: payload,
      }
    );
    if (status === 200) {
      yield put(TransferRetiredActions.getPdfTransationSuccess());
    } else {
      Sentry.captureMessage('getPdfTransation failed: status not 200', {
        level: 'error',
        extra: { payload, status },
      });
      yield put(TransferRetiredActions.getPdfTransationError());
    }
  } catch (error) {
    Sentry.captureException(error, { extra: { payload } });
  }
}

function* getTransationWatcher() {
  yield takeLatest(TransferRetiredTypes.GET_TRANSATION_RETIRED, getTransationRetired);
}

function* getGasrecWatcher() {
  yield takeLatest(TransferRetiredTypes.GET_GASREC_RETIRED, getGasrecRetired);
}

function* getPDFWatcher() {
  yield takeLatest(TransferRetiredTypes.GET_PDF_TRANSATION, getPdfTransation);
}


export default function* rootSaga() {
  yield all([
    fork(getGasrecWatcher),
    fork(getTransationWatcher),
    fork(getPDFWatcher),
  ]);
}
